document.addEventListener('DOMContentLoaded', () => {
  const qtyInputs = document.querySelectorAll('.qty-input');
  qtyInputs.forEach(input => {
    input.addEventListener('change', () => {
      input.closest('form')?.querySelector('[name="update"]')?.click();
    });
  });
});
